import React from "react";
import { Link } from "react-router-dom";

const ThemeStorePromo = () => {
  return (
    <section className="theme-store-promo section-gap">
      <div className="container">
        <div
          className="row align-items-center justify-content-between"
          style={{
            border: "1px solid #ededed",
            borderRadius: "8px",
            padding: "30px",
          }}
        >
          <div className="col-md-8">
            <h3 className="mb-10">Need it live faster?</h3>
            <p className="mb-0">
              Skip the wait and launch on a ready-made theme instead —
              pick one you like and get your website up in days.
            </p>
          </div>
          <div className="col-md-4 text-md-right mt-3 mt-md-0">
            <Link
              to="/theme-store"
              className="primary-btn text-uppercase px-4"
            >
              Browse Ready-Made Themes
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThemeStorePromo;
